import { Controller } from "@tingwu/core";
import { createContext } from "react";

export interface TingwuContextValue {
  getController: () => Controller | undefined;
}

export const TingwuContext = createContext<TingwuContextValue>({
  getController: () => undefined,
});
